/**************************************************
 * Nombre:       Tarjeta_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {FONDOCARD} from "../../Constantes";
import {CalendarMonth, LocalActivityOutlined, StarRate, TaskOutlined} from "@mui/icons-material";
import IconoTexto from "./Componentes/IconoTexto";
import {theme} from "../../Tema";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {verificarMembresia} from "../../CodigoCliente/Funciones/verificarMembresia";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Membresia from "../Dialogos/Dialogo_Membresia";
import {formatoFecha} from "../../Utilidades/formatoFecha";

const Tarjeta_Membresia = () => {
    const cData = useContext(usuarioContext)
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Membresia, titulo: 'Membresía'});
    const [activa, setActivas] = useState(false)


    useEffect(() => {
        setActivas(verificarMembresia(cData.usuario))
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                ...FONDOCARD,
                p: 2,
                color: '#fff',
                minHeight: 200
            }}
        >

            <Dialogo/>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>Membresía</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontSize: 24,
                                fontWeight: 600,
                                color: activa ? theme.palette.primary.main : theme.palette.primary.main + 40
                            }}>{activa ? 'ACTIVA' : 'INACTIVA'}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 3, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                <CalendarMonth sx={{width: 40, height: 40, fill: activa ? '#fff' : '#ffffff80'}}/>
                            </Grid>

                            <Grid container size={{xs: 9, sm: 8, md: 8}} sx={{justifyContent: 'flex-start'}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{color: activa ? '#fff' : '#ffffff80'}}
                                >

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{
                                            fontSize: 12,
                                            fontWeight: 500
                                        }}>{activa ? 'Activo hasta' : 'Termino el'}</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 10, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{
                                            fontSize: 10,
                                            fontWeight: 500
                                        }}>{cData.usuario.fechaMembresia ? formatoFecha(cData.usuario.fechaMembresia) : 'Sin Membresía'}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>


                </Grid>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>Beneficios</Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <IconoTexto Icono={TaskOutlined} texto={activa ? 'x2 en rendimientos' : 'x1 en rendimientos'}
                                    color={activa ? '#fff' : '#ffffff80'}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <IconoTexto Icono={LocalActivityOutlined} texto={activa ? 'x2 en bonos' : 'x1 en bonos'}
                                    color={activa ? '#fff' : '#ffffff80'}/>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Button
                    onClick={() => abrir()}
                    variant={activa ? 'outlined' : 'contained'}
                    fullWidth startIcon={<StarRate/>}>Activar Membresía</Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Membresia

const labels = ['uno', 'dos']

const series = [1, 2]